const carouselItems = [
  {
    title: '咒术回战：涉谷事变篇深度解析',
    desc: '五条悟被封印后的世界格局变化，虎杖悠仁的成长之路与宿傩的最终阴谋。带你逐话回顾这一改变咒术世界格局的史诗篇章。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20illustration%2C%20Japanese%20dark%20fantasy%20manga%20style%2C%20warm%20crimson%20and%20golden%20accents%2C%20dramatic%20lighting%2C%20dynamic%20action%20composition%2C%20professional%20comic%20art%2C%20cinematic%20atmosphere&width=900&height=500&seq=carousel-manga-01&orientation=landscape',
    alt: '咒术回战 涉谷事变篇 深度解析',
    tag: '深度专题',
  },
  {
    title: '海贼王最终章：ONE PIECE的真相',
    desc: '路飞觉醒尼卡形态后，最终之岛拉夫德鲁的秘密即将揭晓。盘点最终章所有伏笔与关键线索。',
    img: 'https://readdy.ai/api/search-image?query=Grand%20adventure%20anime%20illustration%20with%20pirate%20ship%20and%20treasure%2C%20Japanese%20shonen%20manga%20style%2C%20warm%20golden%20and%20ocean%20blue-green%20tones%2C%20epic%20scale%2C%20inspiring%20atmosphere%2C%20cinematic%20wide%20shot&width=900&height=500&seq=carousel-manga-02&orientation=landscape',
    alt: '海贼王最终章 ONE PIECE真相',
    tag: '深度专题',
  },
  {
    title: '葬送的芙莉莲：旅途中的人生哲学',
    desc: '一部关于时间、生命与羁绊的奇幻杰作。芙莉莲的旅程为何能触动无数读者的心弦？',
    img: 'https://readdy.ai/api/search-image?query=Melancholic%20fantasy%20anime%20journey%20illustration%2C%20Japanese%20slice-of-life%20manga%20style%2C%20warm%20amber%20and%20soft%20green%20tones%2C%20nostalgic%20atmosphere%2C%20beautiful%20landscape%2C%20emotional%20storytelling%20vibe&width=900&height=500&seq=carousel-manga-03&orientation=landscape',
    alt: '葬送的芙莉莲 人生哲学之旅',
    tag: '漫评',
  },
  {
    title: '2026年最值得期待的漫画改编动画',
    desc: '从宣布制作到定档播出，盘点今年最受瞩目的漫画改编动画作品，先看原作赢在起跑线。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20adaptation%20announcement%20collage%20illustration%2C%20Japanese%20manga%20to%20anime%20theme%2C%20warm%20coral%20and%20cream%20tones%2C%20exciting%20anticipation%20atmosphere%2C%20dynamic%20montage%2C%20modern%20editorial%20style&width=900&height=500&seq=carousel-manga-04&orientation=landscape',
    alt: '2026漫画改编动画 最值得期待',
    tag: '前瞻',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          焦点专题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">深入探索漫画世界的精彩故事</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group relative bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-200 flex flex-col md:flex-row"
            >
              <div className="md:w-2/5 aspect-[16/10] md:aspect-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <span className="inline-block px-2 py-0.5 rounded bg-accent-100 text-accent-700 text-[10px] font-semibold mb-2 self-start">
                  {item.tag}
                </span>
                <h3 className="font-heading font-bold text-base text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}